module.exports = __webpack_public_path__ + "img/ES3187.ed38d59e.png";